export default __webpack_public_path__ + "static/media/fs-icon.6c43c932.png";